<template>
  <div class="archives fl">
    <div class="title">
      <span
        :class="{'curspan':hive_one==index}"
        v-for="(hive,index) in hive_title"
        :key="index"
        @click="changeTab(index)"
      >{{hive}}</span>
    </div>
    <!-- <div style="padding: 0 20px;">
      <p style="border-bottom:1px #ccc dashed;height:30px;line-height:30px;">本年度<span>（{{year}}年）</span>继续教育要求完成专业课<span style="color:#f00;">{{nian}}</span>学时</p>
      <p style="border-bottom:1px #ccc dashed;height:30px;line-height:30px;">您已经完成专业课<span style="color:#f00;">{{hour}}</span>学时</p>
      <p style="border-bottom:1px #ccc dashed;color:#f60;height:30px;line-height:30px;margin-bottom:5px;">（学习时长达到课程学习要求，并通过考试后，即可完成课程，并获得学时记录）</p>
    </div> -->
    <div class="content">
      <div class="top">
        <ul class="clearfix ul1">
          <li class="l1">年度</li>
          <li>专业分类</li>
          <li>课程名称</li>
          <li class="l2">选学时间</li>
          <li>完成时间</li>
          <li>学习时长</li>
          <li class="l6">学时</li>
          <li>状态</li>
          <!-- <li>成绩</li>
          <li>学时对接</li>
          <li>证书下载</li> -->
        </ul> 
      </div>
      <div class="topcon" v-show="!nodata">
            <ul v-for="item in list" :key="item.id" class="ul2">
              <li class="l1">
                <span>{{item.year}}年</span>
                <span>{{item.type==1?"必修":"选修"}}</span>
                <span :title="item.kecheng_title">{{item.kecheng_title}}</span>
                <span :title="item.time">{{item.time}}</span>
                <span :title="item.pass_time">{{item.is_pass==0?"未完成":item.pass_time}}</span>
                <span :title="item.read_shichang_seconds">{{item.read_shichang_seconds}}</span>
                <span>{{item.xueshi_num}}</span>
                <span>{{item.is_pass==0?"未完成":"已完成"}}</span>
                <!-- <span>{{item.is_pass==0?"暂无":item.last_chengji}}</span>
                <span>{{item.is_duijie}}</span>
                <span @click="downloadCertificate(item.id)" v-if="item.is_pass==1" style="color:#0c69f5">下载证书</span>
                <span v-else >下载证书</span> -->
              </li>
            </ul>
      </div>
      <div class="nodata" v-show="nodata"></div>
      <div class="blocks">
        <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo" :page-size="20"
          layout="total,prev, pager, next, jumper" :total="count" :pager-count="19" v-show="count>20">
        </el-pagination>
      </div>
      <div class="my-certificate" ref="certificate">
        <!-- // <img src="../assets/zs.jpg" class="certificateimg" />
        <div class="certificate-box" v-for="(list,index) in list_cons">
          <p class="certificate-title">
            河南省专业技术人员继续教育网络学习
            <br />合格证明
          </p> -->
          <div class="chive_bh">
            <!-- 证书编号： -->
            <span v-html="chive_bh"></span>
          </div>
          <div class="info1 info">
            <div class="name-box">
              <!-- 姓名： -->
              <span class="name" v-html="list_name"></span>
            </div>
            <div class="idcard-box">
              <!-- 身份证号： -->
              <span class="idcard" v-html="list_id">{{list_id}}</span>
            </div>
          </div>
          <div class="info2 info">
            <div class="sex-box">
              <!-- 性别： -->
              <span class="sex" v-html="sex==0?'女':'男'"></span>
            </div>
            <div class="year-box">
              <!-- 培训年度： -->
              <span class="year" v-html="list_year">
                <!-- 年 -->
              </span>
            </div>
          </div>
          <div class="xueshi">
            <!-- 该学员参加年度专业技术人员继续教育专业科目的网络学习，通过考核。
            <br />累计完成 -->
            <span class="alltime" v-html="list_kcxueshi"></span>
            <span class="alltime2" v-html="list_xueshi"></span>
            <!-- 学时。 -->
          </div>
          <div class="tczm">
            <!-- 特此证明。 -->
          </div>
          <div class="date" >
            <span v-html="list_date.split('-')[0]" class="span1"></span>
            <span v-html="list_date.split('-')[1]" class="span2"></span>
            <span v-html="list_date.split('-')[2]" class="span3"></span>

          </div>
          <div class="blackline"></div>
      </div>
        <!--<img src="../assets/tc_1.png" class="seal" />-->
    </div>
   
  </div>
</template>

<script>
import qs from "qs";
import html2canvas from "html2canvas";
import vue from 'vue'
export default {
  name:'archives',
  data() {
    return {
      nodata: false,
      // pagevalue:true,
      uid: "",
      token: "",
      year: "",
      list: "", //返回来的数据
      name: "",
      id_card: "",
      riqi: "",
      
      sex: "",
      xueshinum: 60,
      hive_title:['全部课程',
      /* '专业课','公需课', */
      ],
      hive_one:0,
      user_dangan_id:'',
      list_cons:[],
      chive_bh:'',
      list_name:'',
      list_id:'',
      list_date:'',
      list_sex:'',
      list_xueshi:'',
      list_year:'',
      list_kcxueshi:'',
      data_time:[],
      theTime:'',
      middle:'',
      hour:'',
      nian:'',
      year:'',
      count: 0,
      page: 1,
      num: 20,
      pageNo: 1,
    };
  },
  created() {
    this.uid = localStorage.getItem("uid");
    this.token = localStorage.getItem("token");
    this.sex = localStorage.getItem("sex");
    if (this.token) {
      this.dangan();
      // this.year_zhibiao();
      this.user_xueshi();
    } else {
      this.removeInfo();
    }
    var date=new Date;
    this.nian = date.getFullYear();
  },
  watch: {
    token: {
      handler: function(val) {
        if (val) {
          this.dangan();
        } else {
          this.removeInfo();
        }
      }
    },
    deep: true
  },
  // updated(){
  //   this.dangan();
  // },
  methods: {
    handleCurrentChange(val) {
        this.page = val
        //  (val)
        // (`当前页: ${val}`);
        this.dangan()
      },
    //获取已经获得的学时
    user_xueshi(){
      var date=new Date;
      var that = this
      var year = {
        uid:this.uid,
        year:date.getFullYear(),
        token:this.token,
        type:'1'
      }
      this.$axios({
        method: "post",
        url:  "/dangan/get_user_xueshi_year",
        data: qs.stringify(year)}).then(res =>{
          // // (res.data.data)
          this.hour = res.data.data[0].get_xueshi_num
          // // (this.hour);
      })
    },
    //获取年度指标
    // year_zhibiao(){
    //   // // (this.nian)
    //   var date=new Date;
    //   var that = this
    //   var year = {
    //     year:date.getFullYear()
    //   }
    //   this.$axios({method: "post",
    //     url:  "/dangan/get_year_zhibiao",
    //     data: qs.stringify(year)}).then(res =>{
    //       // // (res);
    //       // this.year = res.data.data.year
    //       this.nian = res.data.data.zhuanyeke_xueshi_num
    //   })
    // },
    //我的公需课档案
    // dangan_g() {
    //   //获取课程包信息
    //   var that = this;
    //   var data = {
    //     uid: this.uid,
    //     token: this.token,
    //     type:'2'
    //   };
    //   this.$axios({
    //     method: "post",
    //     url:  "/dangan/get_user_dangan",
    //     data: qs.stringify(data)
    //   }).then(res => {
    //     if (res.data.status == "ok") {
    //       // // (res);
    //       // // ("档案记录");
    //       that.list = res.data.data;
    //       // // (that.list);
    //       // if (res.data.data.length) {
    //       //   that.nodata = false;
    //       // } else {
    //       //   that.nodata = true;
    //       // }
    //     } else if (res.data.status == "error") {
    //       this.$message.error({ message: res.data.errormsg, duration: 1600 });
    //     } else if (res.data.status == "relogin") {
    //       this.$message.error({ message: "重新登录", duration: 1600 });
    //       that.removeInfo();
    //     }
    //   });
    //   for(var i=0;i<that.list.length;i++){
    //     var user_dangan_id = that.list[i].id;
    //   }
    //   this.user_dangan_id = user_dangan_id
    // },
    // //我的专业课档案
    // dangan_z() {
    //   //获取课程包信息
    //   var that = this;
    //   var data = {
    //     uid: this.uid,
    //     token: this.token,
    //     type:'1'
    //   };
    //   this.$axios({
    //     method: "post",
    //     url:  "/dangan/get_user_dangan",
    //     data: qs.stringify(data)
    //   }).then(res => {
    //     if (res.data.status == "ok") {
    //       // // (res);
    //       // // ("档案记录");
    //       that.list = res.data.data;
    //       // // (that.list);
    //       // if (res.data.data.length) {
    //       //   that.nodata = false;
    //       // } else {
    //       //   that.nodata = true;
    //       // }
    //     } else if (res.data.status == "error") {
    //       this.$message.error({ message: res.data.errormsg, duration: 1600 });
    //     } else if (res.data.status == "relogin") {
    //       this.$message.error({ message: "重新登录", duration: 1600 });
    //       that.removeInfo();
    //     }
    //   });
    // },
    changeTab: function(index) {
      this.hive_one = index;
      sessionStorage.setItem('hive_one',this.hive_one)
      if (index == 0) {
        this.kemuid = "";
        this.page=1;
        this.dangan();
      } else if (index == 1) {
        this.kemuid = 1;
        this.page=1;
        this.dangan_z();
      } else if (index == 2) {
        this.kemuid = 2;
        this.page=1;
        this.dangan_g();
      }
    },
    removeInfo() {
      var that=this
      localStorage.removeItem("uid");
      localStorage.removeItem("token");
      localStorage.removeItem("sex");
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
      localStorage.removeItem("id_card");
      setTimeout(() => {
        that.$router.push({ path: "/" });
      }, 1600);
    },
    dangan() {
      //获取课程包信息
      var that = this;
      var data = {
        // year: this.year,
        uid: this.uid,
        token: this.token,
        num:this.num,
        page:this.page
      };
      this.$axios({
        method: "post",
        url:  "/dangan/get_user_dangan",
        data: qs.stringify(data)
      }).then(res => {
        if (res.data.status == "ok") {
          //  (res.data.data);
          // // ("档案记录");
          this.count = parseInt(res.data.count)
          that.list = res.data.data;
          for(var i=0;i<res.data.data.length;i++){
            that.middle = res.data.data[i].read_shichang_seconds;
            that.theTime = Math.floor(that.middle%3600);
            // // (that.theTime)
            that.list[i].read_shichang_seconds = Math.floor(that.middle/3600) + "时" + Math.floor(that.theTime/60) + "分"+ that.middle%60 + "秒";
          }
          // // (that.list)
        } else if (res.data.status == "error") {
          this.$message.error({ message: res.data.errormsg, duration: 1600 });
        } else if (res.data.status == "relogin") {
          this.$message.error({ message: "重新登录", duration: 1600 });
          that.removeInfo();
        }
      });
    },
    downloadCertificate: function(num) {
      let that = this;
      var data = {
        user_dangan_id:num,
        uid: this.uid,
        token: this.token
      };
      this.$axios({
        method: "post",
        url:  "/dangan/zhengshu_download",
        data: qs.stringify(data)
      }).then(res => {
        //  (res)
        if (res.data.status == "ok") {
          that.list_cons = res.data.data;
          this.chive_bh = that.list_cons.zhengshu_id;
          this.list_id = that.list_cons.id_card;
          this.list_name = that.list_cons.name;
          this.list_sex = that.list_cons.sex;
          this.list_xueshi = that.list_cons.kecheng_xueshi_num;
          this.list_kcxueshi = that.list_cons.get_xueshi_num;
          this.list_year = that.list_cons.year;
          this.list_date = that.list_cons.date;
          // // (this.list_date.split('-'))
          // if (res.data.data.length) {
          //   that.nodata = false;
          // } else {
          //   that.nodata = true;
          // }
        } else if (res.data.status == "error") {
          this.$message.error({ message: res.data.errormsg, duration: 1600 });
        } else if (res.data.status == "relogin") {
          this.$message.error({ message: "重新登录", duration: 1600 });
          that.removeInfo();
        }
      })
      for (var i = 0; i < that.list.length; i++) {
        if (that.list[i]["id"] == num) {
          // // (that.list[i]["id"] == num);
          that.name = that.list[i]["name"];
          // // ()
          that.year = that.list[i]["year"];
          that.id_card = that.list[i]["id_card"];
          var date = new Date();
          this.year = date.getFullYear();
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
          }
          // var currentdate =
          //   that.year +
          //   '<span style="margin: 0 7px;">年</span>' +
          //   month +
          //   '<span style="margin: 0 7px">月</span>' +
          //   strDate +
          //   '<span style="margin-left:7px;">日</span>';
          // this.riqi = currentdate;
          // // (this.ripi);
          // that.xueshinum =
          //   parseFloat(that.list[i]["get_gongxuke_xueshi_num"]) +
          //   parseFloat(that.list[i]["get_zhuanyeke_xueshi_num"]);
          // // (that.xueshinum);
          if (that.list[i]["is_pass"] == 1) {
            setTimeout(() => {
              html2canvas(this.$refs.certificate).then(function(canvas) {
                var base64 = canvas.toDataURL("image/jpeg", 1);
                var a = document.createElement("a");
                a.href = base64;
                a.download = "证书下载";
                a.click();
              });
            }, 500);
            let isdown = { id: num, uid: this.uid, token: this.token };
            this.$axios({
              method: "post",
              url:  "/dangan/download_notify",
              data: qs.stringify(isdown)
            }).then(function(response) {
              if (response.data.status == "ok") {
                // // ("down");
                // // (response.data);
              } else if (response.data.status == "error") {
                that.$message.error({
                  message: response.data.errormsg,
                  duration: 1600
                });
              } else if (response.data.status == "relogin") {
                that.removeInfo();
              }
            });
          } else {
            this.$message.error({
              message: "您的学时还未达到下载证书的标准，继续努力哦",
              duration: 3000
            });
          }
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.archives {
  width: 948px;
  // border:1px solid red;
  background-color: #fff;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 55px;
    font-size: 18px;
    padding-left: 35px;
    line-height: 55px;
    color: #ad0008;
    box-sizing: border-box;
    border-bottom: 2px solid #eee;
    span{margin-right: 20px;cursor: pointer;color: #b9b9b9;}
    .curspan {
      border-bottom: 2px solid #ad0008;
      padding-bottom: 13px;
      color: #ad0008;
    }
  }
  .content {
    width: 100%;
    min-height: 662px;
    background-color: #fff;
    padding:20px;
    position: relative;
    .top {
      .ul1 {
        background-color: #e1f1ff;
        display: flex;
        width: 100%;
        // padding: 0 20px;
        box-sizing: border-box;
        height: 35px;
        display: flex;
        justify-content: space-between;
        li {
          // width: 910px;
          width: 12.5%;
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          color: #111;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          cursor: pointer;
          // border: 1px solid red;
          // &.l1 {
          //   text-align: left;
          // }
          //  &.l2 {
          //     //  width: 30%;
          // }
          // &.l6 {
          //   // text-align: right;
          // }
        }
      }
    }
    .topcon {
      //  dl{
      //   border: 1px solid #e0e0e0;
      //   margin-top: 5px;
      //   width:906px;
      //   font-size: 10px;
      //   // padding: 0 20px;

      //   dt{ width:100%; height: 36px; background:  #f9f9f9; display: flex; align-items: center; padding-left: 22px; padding-right: 55px;  justify-content: space-between;
      //     span{color: #84a7dd}
      //   }

      //   dd{width: 100%; height: 36px;
      //     ul{width: 100%; height: 36px;   padding-left: 20px;
      //       li{  height: 36px; line-height: 36px; float: left;    width: 119px; text-align: center;}
      //     }
      //   }
      //  }
      .ul2 {
        margin-top:5px;
        width: 100%;
        // border: 1px solid #e0e0e0;
        // padding: 0 20px;
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
        .l1 {
          // width: 910px;
          width: 100%;
          // background:#f9f9f9;
          font-size: 14px;
          color: #868686;
          display: flex;
          cursor: pointer;
          text-align: center;
          span{
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &:nth-child(2n){
            background:#eee;
          }
          // &.l1 {
          //   text-align: left;
          // }
          //   &.l2 {
          //      width: 30%;
          // }
          // &.l6 {
          //   text-align: right;
          //   color: #0c69f5;
          // }
        }
        .l2 {
          // width: 910px;
          width: 100%;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #868686;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          display: flex;
          cursor: pointer;
          span{
            flex: 1;

          }
          span:nth-child(1){
            text-align: left;
          }span:nth-child(9){
            text-align: right;
            color: #AD0008;
          }
        }
      }
    }
    .nodata {
      width: 212px;
      height: 240px;
      margin: 80px auto;
      background-image: url("../assets/nodata.png");
    }
    .blocks{
        position: absolute;bottom: 50px; text-align:center;width: 100%; height:50px; padding-top:8px;
      }
  }
  .my-certificate {
    width: 822px;
    height: 590px;
    position: absolute;
    left: -850px;
    top: -600px;
  }
  .year{
    position: absolute;
    top: 291px;
    left: 470px;
  }
  .chive_bh{
    font-size: 15px;
    position: absolute;
    top: 200px;
    left: 250px;
  }
  .certificate-box {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
  .certificate-box .certificate-title {
    width: 560px;
    line-height: 42px;
    margin: 100px auto 0;
    font-size: 32px;
    text-align: center;
    color: #48538d;
  }
  .certificate-box .info {
    width: 555px;
    display: flex;
  }
  .certificate-box .info1 {
    margin: 60px auto 0;
  }
  .certificate-box .info2 {
    margin: 25px auto 0;
  }
  .certificate-box div {
    font-size: 18px;
    font-family: "KaiTi";
  }
  .certificate-box div span {
    font-size: 18px;
    font-family: "Microsoft YaHei";
  }
  .certificate-box .name-box {
    width: 220px;
    position: absolute;
    top: 241px;
    left: 210px;
  }
  .certificate-box .sex-box {
    width: 220px;
    position: absolute;
    top: 290px;
    left: 210px;
  }
  .certificate-box .xueshi {
    width: 648px;
    margin: 20px auto 0;
    text-indent: 48px;
    font-size: 18px;
    line-height: 30px;
  }
  .alltime {
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-size: 18px;
    display: inline-block;
    text-indent: 0;
    text-align: center;
    position: absolute;
    left: 202px;
    top: 366px;
  }
  .alltime2{
    position: absolute;
    top: 397px;
    left: 280px;
  }
  .certificate-box .blackline {
    width: 60px;
    height: 1px;
    background-color: #000;
    position: absolute;
    left: 160px;
    top: 394px;
  }
  .certificate-box .idcard{
    position: absolute;
    left: 470px;
    top: 245px;
  }
  .certificate-box .tczm {
    width: 648px;
    margin: 20px auto 0;
    text-indent: 72px;
    font-size: 18px;
  }
  .certificate-box .date {
    position: absolute;
    right: 108px;
    bottom: 75px;
    font-size: 18px;
    font-family: "Microsoft YaHei";
  }
  .certificate-box .date span {
    font-size: 18px;
    font-family: "KaiTi";
  }
  .my-certificate .certificateimg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .my-certificate .seal {
    position: absolute;
    right: 100px;
    bottom: 90px;
    width: 146px;
  }
}


.span1{
  position: absolute;
  bottom: 5px;
  right: 152px;
}
.span2{
  position: absolute;
  bottom: 5px;
  right: 87px;
}
.span3{
  position: absolute;
  bottom: 5px;
  right: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/archives.vue